import React, { useEffect } from 'react';

import { ProductSlugs } from '@deque/billing-utils';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import DQUPurchaseNotification from '../components/DQUPurchaseNotification';
import { useGlobalToast } from '../contexts/globalToast';
import { useProducts } from '../contexts/products';

export const PURCHASE_QUERY_NAME = 'purchased';
export const REQUIRES_ADMIN_QUERY_NAME = 'requiresAdminToPurchase';

const usePurchaseNotification = () => {
  const { setContents } = useGlobalToast();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { getProductBySlug } = useProducts();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const purchasedParam = searchParams.get(PURCHASE_QUERY_NAME);
    const requiresAdminParam = searchParams.get(REQUIRES_ADMIN_QUERY_NAME);
    if (purchasedParam) {
      // we navigate from a purchase page to this page using a browser redirect and that means that app is reloaded
      // put here any logic to setup any state, such as Toast messages
      switch (purchasedParam) {
        case ProductSlugs.dequeUniversity:
          // Set toast for Deque University
          setContents(<DQUPurchaseNotification />, 'info');
          break;
        default:
      }

      // React redirect to the same URL but without purchased param
      searchParams.delete(PURCHASE_QUERY_NAME);
      history.push(`${location.pathname}?${searchParams.toString()}`);
    } else if (requiresAdminParam) {
      // we navigate from a purchase page to this page using a browser redirect and that means that app is reloaded
      // put here any logic to setup any state, such as Toast messages
      setContents(
        t(
          'If you have any questions about {{ productName }} subscriptions, please contact your account administrator',
          { productName: getProductBySlug(requiresAdminParam)?.name }
        ),
        'info'
      );

      // React redirect to the same URL but without requiresAdminToPurchase param
      searchParams.delete(REQUIRES_ADMIN_QUERY_NAME);
      history.push(`${location.pathname}?${searchParams.toString()}`);
    }
  }, []);

  return new URLSearchParams(location.search);
};

export default usePurchaseNotification;
